// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__qZWXh","slogan":"styles_slogan__iTPqx","gallery":"styles_gallery__N2avx"};